@if (temSessoes()) {
  <div class="summary__sessions">
    <button
      type="button"
      class="summary__sessions-link"
      title="Situação, custo e sessão de cada agente do Cog nesta reunião"
      (click)="verSessoes.emit()">
      <i class="pi pi-sliders-h" aria-hidden="true"></i> Sessões do Cog
    </button>
  </div>
}

@switch (estado()) {
  @case ('carregando') {
    <div class="summary summary--center">
      <app-cog-loading-spinner />
    </div>
  }
  @case ('erro') {
    <div class="summary summary--center" role="alert">
      <i class="pi pi-exclamation-circle summary__state-icon" aria-hidden="true"></i>
      <strong>{{ erro() }}</strong>
    </div>
  }
  @case ('sem-fala') {
    <div class="summary summary--center">
      <i class="pi pi-volume-off summary__state-icon" aria-hidden="true"></i>
      <strong>Sem fala para analisar</strong>
      <span>
        A gravação desta reunião não tem fala transcrita (por exemplo, o bot saiu da call logo no
        início). Veja o que aconteceu na linha do tempo da aba Detalhes.
      </span>
    </div>
  }
  @case ('sem-transcricao') {
    <div class="summary summary--center">
      <i class="pi pi-file summary__state-icon" aria-hidden="true"></i>
      @if (transcricaoACaminho()) {
        <strong>O resumo sai depois da transcrição</strong>
        <span>
          A gravação ainda está sendo processada. Quando a transcrição chegar, o Cog lê a conversa e
          traz o resumo aqui.
        </span>
      } @else {
        <strong>Sem transcrição, sem resumo</strong>
        <span>O Cog resume a reunião a partir da transcrição, e esta reunião não tem uma.</span>
      }
    </div>
  }
  @case ('nao-iniciado') {
    <div class="summary summary--center">
      <i class="pi pi-sparkles summary__state-icon summary__state-icon--cog" aria-hidden="true"></i>
      <strong>O Cog ainda não resumiu esta reunião</strong>
      <span>
        Ele lê a transcrição, os participantes e os vínculos e traz o resumo, as decisões e os
        próximos passos, cada um com o trecho da fala.
      </span>
      @if (podeGerarAgora()) {
        <app-button
          [label]="'Gerar resumo'"
          [icon]="'pi pi-sparkles'"
          [size]="'small'"
          [type]="'button'"
          [isLoading]="gerando()"
          (sendButtonClick)="gerar.emit()" />
      }
    </div>
  }
  @case ('desligado') {
    <div class="summary summary--center">
      <i class="pi pi-sparkles summary__state-icon" aria-hidden="true"></i>
      <strong>O resumo automático ainda não está ligado</strong>
      <span>
        Quando a geração pelo Cog for ligada, as reuniões novas ganham resumo, decisões, próximos
        passos e capítulos depois da transcrição.
      </span>
    </div>
  }
  @case ('processando') {
    <div class="summary summary--center" aria-live="polite">
      <app-cog-loading-spinner />
      <strong>O Cog está preparando o resumo...</strong>
      <span>Leva poucos minutos. A aba se atualiza sozinha.</span>
    </div>
  }
  @case ('falhou') {
    <div class="summary summary--center" role="alert">
      <i
        class="pi pi-exclamation-triangle summary__state-icon summary__state-icon--warn"
        aria-hidden="true"></i>
      <strong>O Cog não conseguiu resumir esta reunião</strong>
      <span>Pode ter sido uma falha momentânea. Tente gerar de novo.</span>
      @if (podeGerarAgora()) {
        <app-button
          [label]="'Gerar de novo'"
          [icon]="'pi pi-refresh'"
          [theme]="'outline-grey'"
          [size]="'small'"
          [type]="'button'"
          [isLoading]="gerando()"
          (sendButtonClick)="gerar.emit()" />
      }
    </div>
  }
  @case ('pronto') {
    @if (insights(); as i) {
      <div class="summary">
        @if (vazio()) {
          <div class="summary--center">
            <i class="pi pi-info-circle summary__state-icon" aria-hidden="true"></i>
            <strong>Não havia o que resumir</strong>
            <span>A conversa foi curta demais ou não tratou de nenhum assunto de negócio.</span>
          </div>
        }

        @if (i.summary) {
          <section class="summary__block">
            <h4><i class="pi pi-sparkles" aria-hidden="true"></i> Resumo do Cog</h4>
            <p class="summary__text">{{ i.summary }}</p>
          </section>
        }

        @if (i.topics.length) {
          <section class="summary__block">
            <h4>Tópicos</h4>
            <ul class="summary__topics">
              @for (topico of i.topics; track $index) {
                @let inicio = inicioDoTopico(topico);
                <li>
                  @if (temVideo() && inicio !== null) {
                    <button
                      type="button"
                      class="summary__topic summary__topic--clickable"
                      [title]="topico.label + ' (ir para o trecho)'"
                      (click)="irPara.emit(inicio)">
                      {{ rotuloDoTopico(topico) }}
                    </button>
                  } @else {
                    <span class="summary__topic" [title]="topico.label">{{
                      rotuloDoTopico(topico)
                    }}</span>
                  }
                </li>
              }
            </ul>
          </section>
        }

        @if (i.decisions.length) {
          <section class="summary__block">
            <h4>Decisões</h4>
            <ul class="summary__steps">
              @for (decisao of i.decisions; track $index) {
                <li class="summary__step">
                  <span class="summary__step-text">
                    <i class="pi pi-check-circle summary__ok" aria-hidden="true"></i>
                    {{ decisao.text }}
                  </span>
                  @if (decisao.evidence.length) {
                    <app-meeting-evidence
                      [evidencias]="decisao.evidence"
                      [temVideo]="temVideo()"
                      (irPara)="irPara.emit($event)" />
                  } @else {
                    <span class="summary__no-evidence">Sem trecho da fala que confirme</span>
                  }
                </li>
              }
            </ul>
          </section>
        }

        @for (
          grupo of [
            { titulo: 'Próximos passos', itens: i.nextSteps },
            { titulo: 'Pendências', itens: i.pendingItems },
          ];
          track grupo.titulo
        ) {
          @if (grupo.itens.length) {
            <section class="summary__block">
              <h4>{{ grupo.titulo }}</h4>
              <ul class="summary__steps">
                @for (passo of grupo.itens; track $index) {
                  <li class="summary__step">
                    <span class="summary__step-text">{{ passo.text }}</span>
                    <span class="summary__step-meta">
                      @if (passo.owner) {
                        <span>
                          <i class="pi pi-user" aria-hidden="true"></i> {{ passo.owner }}
                          @if (lado(passo.ownerKind); as l) {
                            <span class="summary__side">{{ l }}</span>
                          }
                        </span>
                      }
                      @if (passo.dueDate) {
                        <span>
                          <i class="pi pi-calendar" aria-hidden="true"></i>
                          {{ passo.dueDate | vaultDate }}
                        </span>
                      } @else if (passo.dueText) {
                        <span>
                          <i class="pi pi-calendar" aria-hidden="true"></i> {{ passo.dueText }}
                        </span>
                      }
                    </span>
                    @if (passo.evidence.length) {
                      <app-meeting-evidence
                        [evidencias]="passo.evidence"
                        [temVideo]="temVideo()"
                        (irPara)="irPara.emit($event)" />
                    } @else {
                      <span class="summary__no-evidence">Sem trecho da fala que confirme</span>
                    }
                  </li>
                }
              </ul>
            </section>
          }
        }

        <footer class="summary__footer">
          <span>
            <i class="pi pi-sparkles" aria-hidden="true"></i>
            Gerado pelo Cog a partir da transcrição{{
              i.generatedAt ? ' em ' + (i.generatedAt | vaultDateTime) : ''
            }}. Confira os trechos antes de usar.
          </span>
          @if (podeGerarAgora()) {
            <app-button
              [label]="'Gerar de novo'"
              [icon]="'pi pi-refresh'"
              [theme]="'outline-grey'"
              [size]="'small'"
              [type]="'button'"
              [isLoading]="gerando()"
              (sendButtonClick)="gerar.emit()" />
          }
        </footer>
      </div>
    }
  }
}
